import { useState } from 'react';
import styled from 'styled-components';

import { formatDateFromString } from '../../../../../../utils/formatDateFromString';
import { toast } from 'react-toastify';
import { deleteQuoteApi, quoteMarkApi } from './../../../../../../apis/index';

interface ComponentProps {
  setAllQuotes: (v: any[]) => void;
  allQuotes: any[];
  data: any;
  setViewDetailsModalShow: (v: boolean) => void;
}

const ViewDetailsModal = ({
  allQuotes,
  setAllQuotes,
  data,
  setViewDetailsModalShow,
}: ComponentProps) => {
  const [isMarking, setIsMarking] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleMarkQuote = async () => {
    try {
      setIsMarking(true);
      const res = await quoteMarkApi(
        { markAsRead: !Boolean(data?.markAsRead) },
        data?._id
      );
      console.log(res);
      setIsMarking(false);
      handleUpdatedQuotesFromParent(res?.data?.quote);
    } catch (error: any) {
      setIsMarking(false);
      toast.error(error.response.data.message || 'Something went wrong.');
    }
  };

  const handleUpdatedQuotesFromParent = (res: any) => {
    const tempArr = allQuotes?.map((quote: any) => {
      if (quote._id !== res?.data?.quote?._id) {
        return res?.data?.quote;
      }
      return quote;
    });

    console.log(tempArr);

    setAllQuotes(tempArr);
  };

  const handleDeleteQuote = async () => {
    try {
      setIsDeleting(true);
      const res = await deleteQuoteApi(data?._id);

      console.log(res.data);

      // state.tasks.filter((item: any) => item._id !== payload?.data?.task?._id)

      const tempArr = allQuotes?.filter(
        (quote: any) => quote._id !== res?.data?.quote?._id
      );

      console.log(tempArr);

      setAllQuotes(tempArr);

      setIsDeleting(false);
    } catch (error: any) {
      setIsDeleting(false);
      toast.error(error.response.data.message || 'Something went wrong.');
    }
  };

  console.log(data);
  return (
    <>
      <Wrapper>
        <Modal>
          <Top>
            <span className="text">Quote Details</span>
            <img
              onClick={() => setViewDetailsModalShow(false)}
              src="/assets/icons/cross-icon.svg"
              alt="cross-icon"
            />
          </Top>
          <QuoteDetailsWrapper>
            <SenderInfoWrapper>
              <div className="row">
                <div className="label">Company Name</div>
                <span>:</span>
                <div className="value">{data?.companyName}</div>
              </div>
              <div className="row">
                <div className="label">Quote Sender Name</div>
                <span>:</span>
                <div className="value">
                  {data?.firstName + ' ' + data?.lastName}
                </div>
              </div>
              <div className="row">
                <div className="label">Email</div>
                <span>:</span>
                <div className="value">{data?.email}</div>
              </div>
              <div className="row">
                <div className="label">Phone</div>
                <span>:</span>
                <div className="value">{data?.phone}</div>
              </div>
              <div className="row">
                <div className="label">Date</div>
                <span>:</span>
                <div className="value">
                  {formatDateFromString(data?.createdAt)}
                </div>
              </div>
            </SenderInfoWrapper>
            <InterestedWrapper>
              <div className="label">Interested:</div>
              <div className="interested-text">{data?.interested}</div>
            </InterestedWrapper>
            <ButtonWrapper>
              <DeleteButton onClick={handleDeleteQuote}>
                {isDeleting ? 'Deleting...' : 'Delete'}
              </DeleteButton>
              <MarkButton onClick={handleMarkQuote}>
                {isMarking ? (
                  'Marking...'
                ) : (
                  <>{data?.markAsRead ? 'Mark As Unread' : 'Mark As Read'}</>
                )}
              </MarkButton>
            </ButtonWrapper>
          </QuoteDetailsWrapper>
        </Modal>
      </Wrapper>
    </>
  );
};

export default ViewDetailsModal;

const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  padding: 3%;
`;

const Modal = styled.div`
  width: 750px;
  padding: 15px;
  border-radius: 10px;
  background-color: #fff;

  @media (max-width: 768px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  span.text {
    font-size: 22px;
    font-family: font-medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }

  img {
    width: 20px;
    height: auto;
    cursor: pointer;
  }
`;

const QuoteDetailsWrapper = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding-right: 15px;
  font-size: 18px;

  @media (max-width: 576px) {
    padding-right: 5px;
  }
`;

const SenderInfoWrapper = styled.div`
  .row {
    display: flex;
    font-size: 18px;
    font-family: font-medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 10px;
    flex-wrap: wrap;

    .label {
      width: 180px;
    }

    span {
      margin: 0 15px;
    }
  }

  @media (max-width: 576px) {
    .row {
      display: flex;
      font-size: 15px;
      font-family: font-medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      margin-bottom: 10px;
      .label {
        width: auto;
      }

      span {
        margin: 0 2px;
      }

      .value {
        width: 100%;
      }
    }
  }
`;

const InterestedWrapper = styled.div`
  margin-top: 30px;

  .label {
    font-size: 18px;
    font-family: font-medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 6px;
  }

  .interested-text {
    font-size: 18px;
    font-family: font-medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    word-break: break-all;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
`;

const DeleteButton = styled.div`
  width: 47%;
  background-color: rgba(255, 34, 52, 0);
  padding: 15px;
  border-radius: 5px;
  color: #ff2233;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 500;
  font-family: font-medium;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px solid #ff2233;

  @media (max-width: 576px) {
    width: 48.5%;
    padding: 7px;
    font-size: 16px;
  }

  &:hover {
    background-color: rgba(255, 34, 52, 1);
    color: #ffffff;
  }
`;

const MarkButton = styled.div`
  width: 47%;
  background-color: rgb(93, 165, 237);
  padding: 15px;
  border-radius: 5px;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 500;
  font-family: font-medium;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 576px) {
    width: 48.5%;
    padding: 7px;
    font-size: 16px;
  }

  &:hover {
    background-color: rgb(33, 112, 190);
  }
`;
